import React from 'react';
import classnames from 'classnames';
import {UncontrolledTooltip} from 'reactstrap';


export default ({score, icon, tooltip}) => {
  let classes = {
    [icon]: true
  }
  const nextId = (() => {
    let id = 0;
    return () => "sub-cat-icon-tip" + id++;
  })();
  const id = nextId();
  return (
    <div className="subcat-row" key={`${tooltip}-summary-tt-key`}>
      <span>
        <span className="subcat-icon" id={`${tooltip}-summary-tt`}>
          <span className={classnames(classes)} />
        </span>
        <UncontrolledTooltip placement="top" target={`${tooltip}-summary-tt`}>{tooltip}</UncontrolledTooltip>
      </span>
      <span className="subcat-value">
        {score}
      </span>
    </div>
  );
}
